<template>
  <main class="biograms-page bottom-bg">
    <h1>
      BIOGRAMY: <span class="acier">{{ this.total }}</span>
    </h1>
    <a
      href="javascript:void(0)"
      class="biograms-control arrow-link go-left hidden"
    >
      <div class="arrow-wrapper">
        <svg viewBox="0 0 113.7 90">
          <path
            class="arrow"
            d="M113.7,45 98.7,29.9 68.8,0 58.2,10.7 77.4,29.9 77.4,29.9 0,29.9 0,45 Z"
          />
          <path
            class="arrow arrow2"
            d="M0,45 0,60.1 77.4,60.1 77.4,60.1 58.2,79.3 68.8,90 98.7,60.1 113.7,45 Z"
          />
        </svg>
      </div>
      <span class="acier">A</span>
    </a>
    <div class="swiper-container">
      <div class="biograms-wrapper swiper-wrapper">
        <div
          :class="
            'letter-wrapper swiper-slide letter-wrapper letter-wrapper-' +
            c.letter.toLowerCase()
          "
          v-for="(c, i) in columns"
          :id="i"
          v-bind:key="i"
        >
          <div
            :id="'letter-' + c.letter.toLowerCase()"
            class="letter-box"
            @click="openMe($event)"
            v-bind:style="{ height: c.height + 'px !important' }"
          >
            {{ c.letter }}
          </div>
          <div class="names-box">
            <div  v-for="b in c.biograms" v-bind:key="b.id">
              <router-link :to="'/biogram/' + b.id">{{ b.name }}
              </router-link
            ></div>
          </div>
        </div>
      </div>
    </div>
    <a
      href="javascript:void(0)"
      class="biograms-control arrow-link go-right hidden"
    >
      <span class="acier">Z</span>
      <div class="arrow-wrapper" v-if="this.$parent.columns">
        <svg viewBox="0 0 113.7 90">
          <path
            class="arrow"
            d="M113.7,45 98.7,29.9 68.8,0 58.2,10.7 77.4,29.9 77.4,29.9 0,29.9 0,45 Z"
          />
          <path
            class="arrow arrow2"
            d="M0,45 0,60.1 77.4,60.1 77.4,60.1 58.2,79.3 68.8,90 98.7,60.1 113.7,45 Z"
          />
        </svg>
      </div>
    </a>
  </main>
</template>

<script>
// functions
// uwaga na js

import { eventBus } from "@/main.js";

export default {
  name: "BiogramsContent",
  props: ["columns", "total"],
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      column_class: "",
      opened_class: null,
      letter: null,
      default_height: null,
    };
  },
  mounted: function () {
    this.recalculateCssHeights();
    eventBus.$on("letterChanged", (_letter) => {
      // change opened column when history back button used
      this.letter = _letter;
      this.changeLetter();
    });
  },
  methods: {
    recalculateCssHeights() {

      // get default height

      let _default = this.$el.querySelectorAll(".letter-wrapper")[0];

      this.default_height =
        this.$el.querySelectorAll(".letter-wrapper")[0].clientHeight;

      let _this = this;

      this.columns.forEach((_column) => {
        _column.height = _column.height + _this.default_height;
      });
    },
    openMe(e) {
      let _wrappers = this.$el.querySelectorAll(".letter-wrapper");
      _wrappers.forEach((_div) => {
        _div.classList.remove("opened");
      });

      let _cl = e.target.id.replace("letter-", "");
      this.$el.querySelector(".letter-wrapper-" + _cl).classList.add("opened");

      this.$router.push({
        name: "Biograms",
        params: { letter: _cl.toUpperCase() },
      });
    },
    changeLetter() {
      let _wrappers = this.$el.querySelectorAll(".letter-wrapper");
      _wrappers.forEach((_div) => {
        _div.classList.remove("opened");
      });
      this.$el
        .querySelector(".letter-wrapper-" + this.letter.toLowerCase())
        .classList.add("opened");
    },
  },
};
</script>

<style scoped>
.biograms-wrapper .letter-wrapper {
  margin: 0.5em;
}

/* last slide margin bug https://stackoverflow.com/a/62995187 */
.swiper-slide:last-child {
  margin-right: calc(100% - (100% / 3)) !important;
}
.letter-box {
  height: 15.625rem !important;
  min-width: 7.375rem !important;
}

.biograms-wrapper .letter-wrapper .letter-box {
  min-width: 5rem;
}

.biograms-wrapper .names-box {
display:block;
max-height: 21.25rem;
}

.biograms-wrapper .names-box:after, .biograms-wrapper .names-box:before {
  content: none;
}

.biograms-wrapper .names-box:after, .biograms-wrapper .names-box:after {
  content: none;
}

.biograms-wrapper .names-box a:first-child {
}

.biograms-wrapper .names-box a {
}

.biograms-wrapper .names-box a:last-child {
}

@media (max-width: 480px) {
  body {
    border: 5px solid yellowgreen;
  }
  .biograms-wrapper .letter-wrapper {
    margin: 0.5rem;
    min-width: unset;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Biograms/BiogramsContent.vue